import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Page } from "../../components/Page";
import {
  ContentWrapper,
  SidebarWrapper,
  Backdrop,
  MainContent,
} from "../../components/LayoutComponents";
import { AppNavbar } from "../components/AppNavbar";
import { ChainSidebar } from "./ChainSidebar";
import { useParams } from "react-router-dom";
import type { ChainId } from "@KassaroAB/shared/types/ids";
import { NotFoundView } from "../NotFoundView";
import { CatalogNavProvider } from "../catalog/CatalogNavContext";

export const ChainLayout = () => {
  const { chainId } = useParams<{ chainId: ChainId }>();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  if (!chainId) {
    return <NotFoundView />;
  }

  return (
    <CatalogNavProvider>
      <Page
        fullHeight
        navbar={
          <AppNavbar
            onMenuClick={handleSidebarToggle}
          />
        }
      >
        <ContentWrapper>
          <Backdrop $isOpen={sidebarOpen} onClick={handleSidebarClose} />
          <SidebarWrapper $isOpen={sidebarOpen}>
            <ChainSidebar chainId={chainId} onNavigate={handleSidebarClose} />
          </SidebarWrapper>
          <MainContent>
            <Outlet />
          </MainContent>
        </ContentWrapper>
      </Page>
    </CatalogNavProvider>
  );
};
